import { render } from "./ErrorProcess.vue?vue&type=template&id=422fb7e4&scoped=true"
import script from "./ErrorProcess.vue?vue&type=script&lang=js"
export * from "./ErrorProcess.vue?vue&type=script&lang=js"

import "./ErrorProcess.vue?vue&type=style&index=0&id=422fb7e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422fb7e4"]])

export default __exports__